import { render, staticRenderFns } from "./Brand_Checklist.vue?vue&type=template&id=2cd8b9b2&scoped=true&"
import script from "./Brand_Checklist.vue?vue&type=script&lang=js&"
export * from "./Brand_Checklist.vue?vue&type=script&lang=js&"
import style0 from "./Brand_Checklist.vue?vue&type=style&index=0&id=2cd8b9b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd8b9b2",
  null
  
)

export default component.exports